import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { Link, useParams } from "react-router-dom";
import { UserDetailPanel } from "@/components/users/UserDetailPanel";
import { PageSkeleton } from "@/components/ui/PageSkeleton";
import { useUserProfile } from "@/lib/queries";

const pageVariants = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -4 },
};

export function UserDetailPage() {
  const { id } = useParams<{ id: string }>();
  const userId = Number(id);
  const { data, isLoading, error } = useUserProfile(userId);

  if (isLoading) return <PageSkeleton />;

  if (error || !data?.user) {
    return (
      <motion.div
        variants={pageVariants}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={{ duration: 0.3 }}
        className="space-y-4"
      >
        <Link
          to="/users"
          aria-label="Back to users"
          className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-[var(--color-accent)] text-white opacity-100 transition hover:bg-[var(--color-accent-hover)]"
        >
          <ArrowLeft className="h-5 w-5" />
        </Link>
        <p className="text-sm text-muted">User not found.</p>
      </motion.div>
    );
  }

  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
    >
      <Link
        to="/users"
        aria-label="Back to users"
        className="mb-5 inline-flex h-10 w-10 items-center justify-center rounded-full bg-[var(--color-accent)] text-white opacity-100 transition hover:bg-[var(--color-accent-hover)]"
      >
        <ArrowLeft className="h-5 w-5" />
      </Link>
      <UserDetailPanel
        user={data.user}
        cars={data.cars}
        serviceHistory={data.serviceHistory}
        shftServices={data.shftServices}
      />
    </motion.div>
  );
}
